'use client';

interface TechnicalDocsProps {
  docs: {
    assembly?: string;
    packaging?: string;
    warranty?: string;
    maintenance?: string;
    footModels?: string[];
    [key: string]: any;
  };
  productCategory?: string;
}

export function TechnicalDocs({ docs, productCategory = '' }: TechnicalDocsProps) {
  const isBenchOrTable = productCategory.toLowerCase().includes('tezgah') || 
                        productCategory.toLowerCase().includes('masa');
  
  return (
    <div className="bg-white rounded-xl shadow-sm p-6">
      <div className="space-y-8">
        {/* Montaj Şeması */}
        {docs.assembly && (
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Montaj Şeması</h3>
            <div className="aspect-video bg-gray-50 rounded-lg overflow-hidden">
              <img 
                src={docs.assembly} 
                alt="Montaj şeması" 
                className="w-full h-full object-contain p-4"
              />
            </div>
          </div>
        )}

        {/* Koli Ölçüleri */}
        {docs.packaging && (
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Koli Ölçüleri</h3>
            <div className="aspect-video bg-gray-50 rounded-lg overflow-hidden">
              <img 
                src={docs.packaging} 
                alt="Koli ölçüleri" 
                className="w-full h-full object-contain p-4"
              />
            </div>
          </div>
        )}

        {/* Garanti Belgesi */}
        {docs.warranty && (
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Garanti Belgesi</h3>
            <div className="p-4 border border-gray-100 rounded-lg bg-gray-50">
              <a 
                href={docs.warranty}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-primary font-medium hover:underline"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M10 2a8 8 0 100 16 8 8 0 000-16zm0 14a6 6 0 110-12 6 6 0 010 12zm-1-5h2v2H9v-2zm0-6h2v4H9V5z"></path>
                </svg>
                Garanti belgesini görüntüle
              </a>
              <p className="mt-2 text-sm text-gray-500">
                Bu ürün, satın alma tarihinden itibaren 2 yıl garantilidir. Garanti şartları ve koşulları için belgeyi inceleyiniz.
              </p>
            </div>
          </div>
        )}

        {/* Bakım Kılavuzu */}
        {docs.maintenance && (
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Bakım Kılavuzu</h3>
            <div className="p-4 border border-gray-100 rounded-lg bg-gray-50">
              <a 
                href={docs.maintenance}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-primary font-medium hover:underline"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"></path>
                </svg>
                Bakım kılavuzunu görüntüle
              </a>
              <p className="mt-2 text-sm text-gray-500">
                Ürününüzün ömrünü uzatmak ve görünümünü korumak için bakım talimatlarını izleyiniz.
              </p>
            </div>
          </div>
        )}

        {/* Ayak Modelleri - Sadece tezgah/masa olmayan ürünlerde göster */}
        {!isBenchOrTable && docs.footModels && docs.footModels.length > 0 && (
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Ayak Modelleri</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {docs.footModels.map((model, index) => (
                <div key={index} className="bg-gray-50 rounded-lg p-4">
                  <div className="aspect-square mb-2">
                    <img 
                      src={model} 
                      alt={`Ayak modeli ${index + 1}`} 
                      className="w-full h-full object-contain"
                    />
                  </div>
                  <p className="text-sm text-gray-600 text-center">
                    Model {index + 1}
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
} 